module.exports = __webpack_public_path__ + "static/media/battery-empty.b94735ed.svg";